<!-- 收货人信息table -->
<template>
    <el-dialog append-to-body title="最多选择10个订单" :visible.sync="centerDialogVisible" width="50%">
        <el-table ref="multipleTable" @selection-change="handleSelectionChange" row-key="orderMainId" border
            :header-cell-style="{
                backgroundColor: '#FDEFE7', color: '#000000'
            }" :data="tableData" style="width: 100%">
            <el-table-column :selectable="selectable" :reserve-selection="true" align="center" type="selection"
                width="55"> </el-table-column>
            <el-table-column align="center" width="180" prop="orderMainId" label="订单编号">
            </el-table-column>
            <el-table-column align="center" width="150" prop="name" label="下单时间">
                <template slot-scope="scope">
                    {{ scope.row.createTime | dateFormatHms }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="address" label="订单金额" width="180">
                <template slot-scope="scope">
                    <span style="color: rgb(216, 27, 67);">{{ scope.row.currency + scope.row.orderPrice }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="支付金额">
                <template slot-scope="scope">
                    <span style="color: rgb(216, 27, 67);">{{ scope.row.currency + scope.row.payPrice }}</span>
                </template>
            </el-table-column>
        </el-table>


        <span slot="footer" class="dialog-footer">
            <Pagination :currentPage="init.page" :pageSizes="pageSizes" :parentPageSize="10" :totalNumber="AllpagesNum"
                @loadTable='loadTable'></Pagination>
            <el-button type="primary" @click="save">确 定</el-button>
            <el-button @click="centerDialogVisible = false">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import OrderApi from '@/components/Api/order'

export default {
    components: {
        Pagination
    },
    props: {
        //默认勾选的那条数据
        defaultGou: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            init: {
                "page": 1,
                "q": {
                    "status": 3
                },
                "size": 10
            },
            pageSizes: [10, 20, 25, 30],
            AllpagesNum: 0,
            tableData: [],
            centerDialogVisible: false,
            multipleSelection: [],
        }
    },
    computed: {},
    watch: {},
    methods: {
        selectable(row) {
            return !(row.orderMainId == this.defaultGou)
        },
        initClick() {
            this.myExpensesList(ids)
            this.centerDialogVisible = true
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //保存
        save() {
            if (this.multipleSelection.length > 10) {
                this.$message.warning({ message: '一次最多勾选十条订单' });
            } else {
                let ids = []
                let price = 0 //总价格
                this.multipleSelection.forEach(item => {
                    let obj = {
                        orderId: item.orderMainId,
                        price: item.invoicePrice
                    }
                    ids.push(obj)
                    price += item.payPrice
                })
                this.$message.success({ message: '保存成功' })
                this.$emit('orderClick', ids, price)
                this.centerDialogVisible = false
            }
        },
        //获取总订单了列表(我的支出)
        myExpensesList(ids) {
            new OrderApi("order")
                .myExpenses(this.init)
                .then((res) => {
                    if (res.status == 200) {
                        this.tableData = res.data.records
                        this.AllpagesNum = res.data.total
                        this.$nextTick(() => {
                            this.tableData.forEach(row => {
                                if (ids.findIndex(n => n.orderId === row.orderMainId) !== -1) {
                                    this.$refs.multipleTable.toggleRowSelection(row, true);
                                }
                            })
                        });
                    } else {
                        this.$message.error({ message: res.statusText });
                    }
                });
        },
        loadTable(page, size) {
            this.init.size = size
            this.init.page = page
            this.myExpensesList()
        },
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>